import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import history from '../../core/history';

import { NavItem } from 'react-bootstrap';
// Redux action
import { toggleClose } from '../../actions/Menu/toggleControl';

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function NavLink({ to, children, onClick, noLink, className }) {
  const dispatch = useDispatch();

  const handleClick = (event) => {
    dispatch(toggleClose());

    if (onClick) {
      onClick(event);
    }

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return;
    }

    if (event.defaultPrevented === true) {
      return;
    }

    event.preventDefault();

    if (!noLink) {
      history.push(to);
    }
  };

  return (
    <NavItem href={to} onClick={handleClick} className={className}>
      {children}
    </NavItem>
  );
}

NavLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.any,
  noLink: PropTypes.bool,
  className: PropTypes.string,
};

export default NavLink;
